import { ref } from 'vue'

export interface ToastMessage {
  id: number
  type: 'success' | 'error' | 'info' | 'warning'
  text: string
  duration: number
}

const toasts = ref<ToastMessage[]>([])
let nextId = 0

export function useToast() {
  function show(text: string, type: ToastMessage['type'] = 'info', duration = 4000) {
    const id = nextId++
    toasts.value.push({ id, type, text, duration })

    if (duration > 0) {
      setTimeout(() => {
        remove(id)
      }, duration)
    }

    return id
  }

  function remove(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  const success = (text: string, duration?: number) => show(text, 'success', duration)
  const error = (text: string, duration?: number) => show(text, 'error', duration ?? 8000)
  const info = (text: string, duration?: number) => show(text, 'info', duration)
  const warning = (text: string, duration?: number) => show(text, 'warning', duration ?? 6000)

  return {
    toasts,
    show,
    remove,
    success,
    error,
    info,
    warning,
  }
}
